import { render, staticRenderFns } from "./benefits-confirm-modal.vue?vue&type=template&id=04fb4672&scoped=true"
import script from "./benefits-confirm-modal.vue?vue&type=script&lang=js"
export * from "./benefits-confirm-modal.vue?vue&type=script&lang=js"
import style0 from "./benefits-confirm-modal.vue?vue&type=style&index=0&id=04fb4672&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04fb4672",
  null
  
)

export default component.exports